import loadable from '@loadable/component';

import React from 'react';
import { PropTypes } from 'prop-types';

const RGBShiftImage = loadable(async () => {
    const { RGBShiftImage: a } = await import('./../../../3d');
    return a;
});

const MainImage = ({ styles, src, isActive }) => {
    return (
        <div className={styles.container}>
            <div className={styles.shiftContainer}>{isActive && <RGBShiftImage image={src} />}</div>
        </div>
    );
};

MainImage.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
        shiftContainer: PropTypes.string.isRequired,
    }).isRequired,
    src: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
};

export default MainImage;
